import React from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";

/**
 * Custom header cell for the "Promise to Pay" column in Aging grids.
 * Displays an asterisk and shows a tooltip explaining the SDRA amount for manufacturers.
 */
export function PromiseToPayHeaderCell(props) {
  const tooltipMessage =
    "If a payer is a mfg, then the amount shown is the SDRA amount";
  return (
    <Tooltip anchorElement="target" position="top">
      <span className="k-cell-inner">
        <span className="k-link" onClick={props.onClick}>
          <span className="k-column-title" title={tooltipMessage}>
            Promise to Pay*
            {props.children}
          </span>
        </span>
      </span>
    </Tooltip>
  );
}
